import { ISearchEntityRequest, ISearchEntityResponse, IActionResponse, IAppParams } from "../models";
import { ENDPOINTS } from "../config";
import { generateRequest } from "../utils";

export async function performSearch(options: ISearchEntityRequest, appParams: IAppParams): Promise<IActionResponse<ISearchEntityResponse>> {
    const entityLimitWithDocs = 15;
    let baseSearchRequest = Object.assign({}, BASE_SEARCH_REQUEST, options);
    if (appParams.isprint === "true") {
        delete baseSearchRequest.limit;
    }
    let response = <IActionResponse<ISearchEntityResponse>>{};
    let promiseArr = [];

    if (baseSearchRequest.include.documents && baseSearchRequest.limit > entityLimitWithDocs) {
        let orignialLimit = baseSearchRequest.limit;
        let start = 0;
        while (promiseArr.length <= Math.max(orignialLimit / entityLimitWithDocs)) {
            baseSearchRequest.limit = entityLimitWithDocs;
            baseSearchRequest.start = start;
            promiseArr.push(fetchDataFromFundPress(baseSearchRequest));
            start += entityLimitWithDocs;
        }

        let responseWithDocs = await Promise.all(promiseArr);
        response = responseWithDocs.reduce((acc, current) => {
            if (!acc.data) {
                acc.data = {
                    total: orignialLimit,
                    limit: orignialLimit,
                    values: []
                };

            }

            acc.data.values.push(...current.data.values);
            return acc;
        }, {});
    }
    else {
        response = await fetchDataFromFundPress(baseSearchRequest);
    }

    return response;
}

async function fetchDataFromFundPress(baseSearchRequest) {
    let response = <IActionResponse<ISearchEntityResponse>>{};
    let request = await fetch(ENDPOINTS.fund.searchEntity, generateRequest("POST", baseSearchRequest));
    if (request.ok) {
        response.data = Object.assign({}, await request.json());
    } else {
        response.error = new Error(request.statusText);
    }
    return response;
}

export const BASE_SEARCH_REQUEST: ISearchEntityRequest = {
    type: "FUND",
    search: [],
    include: {},
    culture: "en-GB",
    applyFormats: false,
    start: 0,
    limit: 100
};

export const RANKIA_PERFORMANCE_REQUEST: ISearchEntityRequest = {
    type: "FUND",
    search: [{ "property": "product_range", "values": ["OEIC"], "matchtype": "MATCH" }],
    sort: { "key": "asset_class", "direction": "ASC" },
    include: {},
    applyFormats: true,
    culture: "en-GB",
    limit: 100,
    start: 0
};



// WEBPACK FOOTER //
// ./src/client/data/search.ts